import React, { FC, useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "dayjs/locale/en-gb";
import "dayjs/locale/ar";
import { ar, enUS } from "date-fns/locale";
import dayjs from 'dayjs';
import { useRouter } from 'next/router';

interface DateRangePickerMobileProps {
  minDate?: dayjs.Dayjs;
  maxDate?: dayjs.Dayjs;
  startDate: dayjs.Dayjs | null;
  endDate: dayjs.Dayjs | null;
  className?: string;
  onChange: (
    startDate: dayjs.Dayjs | null,
    endDate: dayjs.Dayjs | null
  ) => void;
  dropdownIsOpen: boolean;
}

const DateRangePickerMobile: FC<DateRangePickerMobileProps> = ({
  minDate,
  maxDate,
  startDate,
  endDate,
  onChange,
  dropdownIsOpen,
}) => {
  const router = useRouter();
  const locale = router.locale ?? 'en';
  const today = dayjs().startOf("day");
  const [value, setValue] = useState<[dayjs.Dayjs | null, dayjs.Dayjs | null]>([
    startDate,
    endDate,
  ]);
  const [dateRangeUpdated, setDateRangeUpdated] = useState<boolean>(false);
  const [open, setOpen] = useState(dropdownIsOpen);
  const [selectingStartDate, setSelectingStartDate] = useState<boolean>(true);

  useEffect(() => {
    onChange(value[0], value[1]);
    setOpen(false);
    
  }, [dateRangeUpdated, locale]);

  useEffect(() => {
    setValue([startDate, endDate]);
  }, [startDate, endDate]);

  const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
    const [newStart, newEnd] = dates;
    const start = newStart ? dayjs(newStart) : null;
    const end = newEnd ? dayjs(newEnd) : null;
    if (selectingStartDate) {
      setValue([start, null]);
      setSelectingStartDate((prev) => !prev);
      return;
    } else {
      if (start && end && end.isSame(start, "day")) {
        setValue([start, start.add(1, "day")]);
        setDateRangeUpdated((prevState) => !prevState);
        setOpen((prevState) => !prevState);
        setSelectingStartDate((prev) => !prev);
        return;
      }
      if (end === null) {
        setValue([start, null]);
        return;
      }
      setValue((prev) => [prev[0], end]);
      setSelectingStartDate((prev) => !prev);
      setDateRangeUpdated((prevState) => !prevState);
      setOpen((prevState) => !prevState);
      return;
    }
  };

  const getDayClassName = (date: Date) => {
    const day = dayjs(date);
    if (value[0] && day.isSame(value[0], "day")) {
      return "custom-start-date";
    }
    if (value[1] && day.isSame(value[1], "day")) {
      return "custom-end-date";
    }
    return "";
  };

  return (
    <div className='DateRangePickerMobile mx-4  mt-8' data-testid='DateRangePickerMobile'>
      <DatePicker
        locale={locale === "ar" ? ar : enUS}
        selected={value[0]?.toDate() || null}
        startDate={value[0]?.toDate() || null}
        endDate={value[1]?.toDate() || null}
        onChange={handleDateRangeChange}
        selectsRange
        minDate={minDate ? minDate.toDate() : today.toDate()}
        maxDate={
          maxDate ? maxDate.toDate() : today.add(1, "year").toDate()
        }
        monthsShown={2}
        inline
        dayClassName={getDayClassName}
        calendarClassName="vertical-calendar"
      
      />

    </div>
  );
};



export default DateRangePickerMobile;
